import { Modal } from "@/components/ui/Modal";
import { DevRoleSwitcherPanel } from "@/components/DevRoleSwitcherPanel";

export interface DevRoleSwitchModalProps {
  open: boolean;
  onClose: () => void;
}

export function DevRoleSwitchModal({ open, onClose }: DevRoleSwitchModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Dev: Rolle simulieren"
      description="Wähle eine oder mehrere Gruppen für die Simulation. Deine echten Entra-Zuweisungen bleiben unverändert."
      size="lg"
    >
      <DevRoleSwitcherPanel onApplied={onClose} />
    </Modal>
  );
}
